import { all, takeLatest } from 'redux-saga/effects';

import {
  createDeviceService,
  deleteDeviceService,
  deleteCurrentDeviceService,
  moveDeviceService,
  moveCurrentDeviceService,
  transferDeviceService,
  transferCurrentDeviceService,
  updateDeviceService,
  updateCurrentDeviceService,
  updateDeviceCommonService,
  hideDeviceService,
  fetchRealtimeDatasService,
} from '../services';
import EntryActionTypes from '../../../constants/EntryActionTypes';

export default function* deviceWatchers() {
  yield all([
    takeLatest(EntryActionTypes.DEVICE_CREATE, ({ payload: { data } }) =>
      createDeviceService(data),
    ),
    takeLatest(EntryActionTypes.DEVICE_UPDATE, ({ payload: { id, data } }) =>
      updateDeviceService(id, data),
    ),
    takeLatest(EntryActionTypes.DEVICE_COMMON_UPDATE, ({ payload: { id, data } }) =>
      updateDeviceCommonService(id, data),
    ),
    takeLatest(EntryActionTypes.CURRENT_DEVICE_UPDATE, ({ payload: { data } }) =>
      updateCurrentDeviceService(data),
    ),
    takeLatest(EntryActionTypes.DEVICE_HIDE, ({ payload: { id } }) => hideDeviceService(id)),
    takeLatest(EntryActionTypes.DEVICE_MOVE, ({ payload: { id, lineId, index } }) =>
      moveDeviceService(id, lineId, index),
    ),
    takeLatest(EntryActionTypes.CURRENT_DEVICE_MOVE, ({ payload: { lineId, index } }) =>
      moveCurrentDeviceService(lineId, index),
    ),
    takeLatest(EntryActionTypes.DEVICE_TRANSFER, ({ payload: { id, siteId, lineId, index } }) =>
      transferDeviceService(id, siteId, lineId, index),
    ),
    takeLatest(EntryActionTypes.CURRENT_DEVICE_TRANSFER, ({ payload: { siteId, lineId, index } }) =>
      transferCurrentDeviceService(siteId, lineId, index),
    ),
    takeLatest(EntryActionTypes.DEVICE_DELETE, ({ payload: { id } }) => deleteDeviceService(id)),
    takeLatest(EntryActionTypes.CURRENT_DEVICE_DELETE, () => deleteCurrentDeviceService()),
    takeLatest(EntryActionTypes.FETCH_DATA_REALTIME, () => fetchRealtimeDatasService()),
  ]);
}
